import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// Создаем глобальную ссылку для хранения последней точки клика
const lastClickedFromRef = { current: null };

// Выносим функцию наружу
export const setReturnPoint = (selector) => {
  lastClickedFromRef.current = selector;
};

const NavigatorWrapper = styled.div`
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 1000;
  transition: all 0.3s ease;
`;

const NavigatorButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: rgba(248, 54, 125, 0.9);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  transform: ${props => props.$isDown ? 'rotate(180deg)' : 'none'};

  &:hover {
    background: #F8367D;
    transform: ${props => props.$isDown ? 
      'rotate(180deg) translateY(-2px)' : 
      'translateY(-2px)'
    };
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  svg {
    font-size: 24px;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    svg {
      font-size: 20px;
    }
  }
`;

const ScrollNavigator = () => {
  const [showNavigator, setShowNavigator] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const lastScrollY = React.useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Показываем навигатор только после прокрутки на 200px
      setShowNavigator(currentScrollY > 200);
      
      // Определяем направление прокрутки
      setIsScrollingDown(currentScrollY > lastScrollY.current);
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    if (isScrollingDown) {
      // Если скроллим вниз, то возвращаемся к точке клика или наверх
      if (lastClickedFromRef.current) {
        const element = document.querySelector(lastClickedFromRef.current);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          lastClickedFromRef.current = null;
        }
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    } else {
      // Если скроллим вверх, то к низу страницы
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

  if (!showNavigator) return null;

  return (
    <NavigatorWrapper>
      <NavigatorButton 
        onClick={handleClick} 
        $isDown={!isScrollingDown}
        title={isScrollingDown ? "Scroll to top" : "Scroll to bottom"}
      >
        <KeyboardArrowUpIcon />
      </NavigatorButton>
    </NavigatorWrapper>
  );
};

export { ScrollNavigator }; 